//---- Automatically generated, don't update this part ----

import Transform from "@ember-data/serializer/transform";
import Performer from "parog-web/models/performer";

export default class PerformerTransform extends Transform {
  override deserialize(serialized) {
    if (serialized) {
      return new Performer(serialized);
    }

    return null;
  }

  override serialize(deserialized) {
    return deserialized?.toJson();
  }
  //---- End of generated code ----
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/transform" {
  export default interface ModelRegistry {
    performer: PerformerTransform;
  }
}
